import { render } from "./FPluginIndoorMap.vue?vue&type=template&id=20c6ec34&scoped=true"
import script from "./FPluginIndoorMap.vue?vue&type=script&lang=js"
export * from "./FPluginIndoorMap.vue?vue&type=script&lang=js"

import "./FPluginIndoorMap.vue?vue&type=style&index=0&id=20c6ec34&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c6ec34"]])

export default __exports__